import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormKeys, RoofType } from '@nx-customer-apps/shared/enums';
import { FormOptions } from '@nx-customer-apps/shared/interfaces';
import { CheckboxSet, MultiTextbox, RadioQuestion } from '@nx-customer-apps/shared/utils';

@Injectable({
    providedIn: 'root'
})
export class RoofTypeFormService {
    constructor() {}

    public getRoofTypeQuestions(options?: FormOptions): (RadioQuestion | MultiTextbox | CheckboxSet)[] {
        return this.getRoofType(options);
    }

    private getRoofType(options?: FormOptions): [RadioQuestion] {
        return [
            new RadioQuestion({
                description: 'HEATLOAD.ROOF_DIMENSIONS.ROOF_TYPE.DESCRIPTION',
                key: FormKeys.RoofType,
                validators: [Validators.required],
                styles: 'ca-radio-no-circle ca-radio-thick ca-radio-columns',
                options: [
                    { key: 'HEATLOAD.ROOF_DIMENSIONS.ROOF_TYPE.FLAT', value: RoofType.Flat, img: 'assets/images/flat-roof.png' },
                    { key: 'HEATLOAD.ROOF_DIMENSIONS.ROOF_TYPE.PENT', value: RoofType.SinglePitch, img: 'assets/images/pent-roof.png' },
                    { key: 'HEATLOAD.ROOF_DIMENSIONS.ROOF_TYPE.GABLE', value: RoofType.Saddle, img: 'assets/images/gable-roof.png' },
                    { key: 'HEATLOAD.ROOF_DIMENSIONS.ROOF_TYPE.HIPPPED', value: RoofType.Hipped, img: 'assets/images/hipped-roof.png' },
                    {
                        key: 'HEATLOAD.ROOF_DIMENSIONS.ROOF_TYPE.HALF_HIPPPED',
                        value: RoofType.HalfHipped,
                        img: 'assets/images/half-hipped-roof.png'
                    }
                ],
                value: options?.questions?.[FormKeys.RoofType]?.value
            })
        ];
    }
}
